<template>
  <div class>
    <AppPaginaTitulo titulo="Lixeira" descricao="Recupere ou remova estudos" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card mb-4 shadow-sm">
            <div class="card-body">
              <b-form>
                <AppFormCabecalho
                    titulo="Filtros da Busca"
                    icon="mdi mdi-folder-search"
                >
                </AppFormCabecalho>
                <transition enter-active-class="animated fadeIn">
                  <div>
                    <b-form-row>
                      <b-form-group
                          id="servidor"
                          class="col col-lg-4"
                          label="Servidor PACS"
                          label-for="servidor"
                      >
                        <v-select
                            :clearable="false"
                            v-model="busca.servidor"
                            :options="servidores"
                            :reduce="s => s.id" label="nome"></v-select>
                      </b-form-group>
                    </b-form-row>
                    <b-button variant="success" @click="buscarLixeira">
                      <i class="mdi mdi-magnify"></i> Buscar Lixeira
                    </b-button>
                  </div>
                </transition>
              </b-form>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-body">
              <LixeiraTable :estudos="estudos" :loading-busca="loadingBusca" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BuscarEstudoApi from "../api/buscarEstudoApi";
import ServidorApi from "../api/servidorApi";
import DatePicker from "vue2-datepicker";

import AppPaginaTitulo from "../components/layout/AppPaginaTitulo.vue";
import AppFormCabecalho from "../components/layout/AppFormCabecalho.vue";
import AppLoading from "../components/util/AppLoading.vue";
import LixeiraTable from "../components/estudo/LixeiraTable.vue";

export default {
  name: "buscar-estudo",
  components: {
    AppPaginaTitulo,
    AppFormCabecalho,
    AppLoading,
    LixeiraTable,
    DatePicker
  },
  data() {
    return {
      busca: {
        servidor: ""
      },
      servidores: [],
      loadingBusca: false,
      estudos: [],
      watchUnidadeFn: null
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getServidores();
  },
  methods: {
    getServidores() {
      ServidorApi.lista({
        unidade: this.$store.getters["autenticacao/unidadeAtual"]
      }).then(resp => {
        this.servidores = resp.data;
        if (this.servidores.length) {
          this.busca.servidor = this.servidores[0].id;
        }
      });
    },
    buscarLixeira(){
      this.loading(true);
      BuscarEstudoApi.lixeira({servidor: this.busca.servidor}).then(resp =>{
        this.estudos = resp.data;
        this.loading(false);
      }).catch(() => {
        this.estudos = [];
        this.loading(false)
      })
    },
    loading(status){
      this.loadingBusca = status;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      /*vm.loading(true);
      UsuarioApi.get(vm.id).then(resp => {
        vm.setUsuario(resp.data);
        vm.loading(false);
      });*/
    });
  },
};
</script>
